import { takeLatest, call, take, fork, put, cancel, select, spawn, takeEvery } from 'redux-saga/effects';
import { channel } from 'redux-saga';
import { subscribe, unsubscribe } from '@push-component/client';
import { BYO_EVENT_UPDATES } from '@push-component/constants';
import { BYO_MARKETS_REQUEST, BYO_MARKETS_START_UPDATE_EVENT_SUBSCRIPTION, BYO_MARKETS_STOP_UPDATE_EVENT_SUBSCRIPTION, BYO_MARKETS_CLEAR_ALL, } from '../constants';
import { hideEventLevelError, showEventLevelError, marketFetchingStarted, saveMarkets, } from '../actions';
import { getMarketsData } from '../../dataProviders';
import { ENGB, PUSH_SUBSCRIBE_OWNER } from '../../constants';
const subscribeChannel = channel();
let updateTask;
export function* cancelEventUpdatesTask() {
    const eventId = yield select(state => state.slip.eventId);
    if (eventId) {
        unsubscribe({
            owner: PUSH_SUBSCRIBE_OWNER,
            type: BYO_EVENT_UPDATES,
            locale: ENGB,
            eventId,
        });
    }
    if (updateTask && !updateTask.isCancelled()) {
        yield cancel(updateTask);
    }
}
const addActiveInSelections = (currMark, subMark, activeKey) => {
    const currMarkSelections = Object.keys(currMark === null || currMark === void 0 ? void 0 : currMark.selections);
    const subMarkSelections = Object.keys(subMark === null || subMark === void 0 ? void 0 : subMark.selections);
    for (let i = 0; i < currMarkSelections.length; i += 1) {
        for (let j = 0; j < subMarkSelections.length; j += 1) {
            const selecsCurrMark = currMark === null || currMark === void 0 ? void 0 : currMark.selections[currMarkSelections[i]];
            const selecsSubMark = subMark === null || subMark === void 0 ? void 0 : subMark.selections[subMarkSelections[j]];
            if ((selecsCurrMark.id === selecsSubMark.id))
                selecsCurrMark[activeKey] = selecsSubMark[activeKey];
        }
    }
};
const addActiveObjectWithSelections = (currMark, subMark, activeKey) => {
    const currMarkKeys = Object.keys(currMark);
    const subMarkKeys = Object.keys(subMark);
    for (let i = 0; i < currMarkKeys.length; i += 1) {
        for (let j = 0; j < subMarkKeys.length; j += 1) {
            const currMarkEl = currMark[currMarkKeys[i]];
            const subMarkEl = subMark[subMarkKeys[j]];
            if ((currMarkEl === null || currMarkEl === void 0 ? void 0 : currMarkEl.id) === (subMarkEl === null || subMarkEl === void 0 ? void 0 : subMarkEl.id)) {
                currMarkEl[activeKey] = subMarkEl[activeKey];
                if ((currMarkEl === null || currMarkEl === void 0 ? void 0 : currMarkEl.selections) && (subMarkEl === null || subMarkEl === void 0 ? void 0 : subMarkEl.selections))
                    addActiveInSelections(currMarkEl, subMarkEl, activeKey);
            }
        }
    }
};
const addActiveInUpdateMarkets = (currentMarkets, subsMarkets) => {
    const activeKey = 'active';
    const copyCurrentMarkets = Object.assign({}, currentMarkets);
    const { byoMarketGroups: currentByoMarketGroups } = copyCurrentMarkets;
    const { byoMarketGroups: subByoMarketGroups } = subsMarkets;
    currentByoMarketGroups.forEach((currMarkEl) => {
        subByoMarketGroups.forEach((subMarkEl) => {
            const keysCurrMarket = Object.keys(currMarkEl === null || currMarkEl === void 0 ? void 0 : currMarkEl.markets);
            const keysSubMarket = Object.keys(subMarkEl === null || subMarkEl === void 0 ? void 0 : subMarkEl.markets);
            for (let i = 0; i < keysCurrMarket.length; i += 1) {
                for (let j = 0; j < keysSubMarket.length; j += 1) {
                    const currMark = currMarkEl === null || currMarkEl === void 0 ? void 0 : currMarkEl.markets[keysCurrMarket[i]];
                    const subMark = subMarkEl === null || subMarkEl === void 0 ? void 0 : subMarkEl.markets[keysSubMarket[j]];
                    if (currMark.id === subMark.id) {
                        currMark[activeKey] = subMark[activeKey];
                        if (subMark.selections && currMark.selections)
                            addActiveInSelections(currMark, subMark, activeKey);
                        if (!subMark.selections)
                            addActiveObjectWithSelections(currMark, subMark, activeKey);
                    }
                }
            }
        });
    });
    return copyCurrentMarkets;
};
export function* updateEventUpdatesSaga(eventId) {
    if (eventId) {
        subscribe({
            owner: PUSH_SUBSCRIBE_OWNER,
            type: BYO_EVENT_UPDATES,
            locale: ENGB,
            eventId,
            callback: subscribeChannel.put,
        });
        while (true) {
            const action = yield take(subscribeChannel);
            const currentMarkets = yield select(state => state.markets.data);
            const newUpdateEventMarketObject = addActiveInUpdateMarkets(currentMarkets, action.data);
            yield put(saveMarkets(newUpdateEventMarketObject));
        }
    }
}
export function* clearAllSaga() {
    yield call(cancelEventUpdatesTask);
}
export function* enableUpdateEventTask() {
    const eventId = yield select(state => state.slip.eventId);
    if (eventId) {
        updateTask = yield spawn(updateEventUpdatesSaga, eventId);
    }
}
export function* getMarketsSaga(action) {
    try {
        const { locale, eventId, useBYOFreedom } = action.payload;
        yield put(hideEventLevelError());
        yield put(marketFetchingStarted());
        const response = yield call(getMarketsData, locale, eventId, useBYOFreedom);
        yield put(saveMarkets(response));
        yield call(cancelEventUpdatesTask);
        updateTask = yield spawn(updateEventUpdatesSaga, eventId);
    }
    catch (error) {
        yield put(showEventLevelError(error.toString()));
    }
}
export function* getMarketsWatcher() {
    yield takeLatest(BYO_MARKETS_REQUEST, getMarketsSaga);
}
export function* startEventUpdatesSubscription() {
    yield takeEvery(BYO_MARKETS_START_UPDATE_EVENT_SUBSCRIPTION, enableUpdateEventTask);
}
export function* stopEventUpdatesSubscription() {
    yield takeEvery(BYO_MARKETS_STOP_UPDATE_EVENT_SUBSCRIPTION, cancelEventUpdatesTask);
}
export function* clearAllMarketsWatcher() {
    yield takeEvery(BYO_MARKETS_CLEAR_ALL, clearAllSaga);
}
const marketsSagas = [
    fork(getMarketsWatcher),
    fork(startEventUpdatesSubscription),
    fork(stopEventUpdatesSubscription),
    fork(clearAllMarketsWatcher)
];
export default marketsSagas;
